import React from "react";
import { MdAddCircle } from "react-icons/md";
import SearchInputBox from "../../../../components/design/searchInputBox/SearchInputBox";
import { StarChartsActionPresentationProps } from "../../types/types";
import {
  StarChartsActionCol,
  StarChartsActionWrapper,
  StarChartsButton,
} from "./starChart.action.presentation.styles";
const StarChartsActionPresentation: React.FC<StarChartsActionPresentationProps> = ({
  openStarChartsAddHandler,
  term,
  setTerm
}) => {

  return (
    <StarChartsActionWrapper style={{justifyContent:"space-between", paddingTop:35}}>
      <StarChartsActionCol style={{ width: '24%' }}>
        <SearchInputBox
          name="starCharts"
          type="Search StarChart"
          placeholder="Search StarCharts"
          value={term}
          onChange={(e) => { setTerm!(e.target.value) }}
        />
      </StarChartsActionCol>
      <StarChartsActionCol style={{width:'auto', padding:0}}>
        <StarChartsButton
          style={{
            padding:"6px 4px 6px 20px",
            fontSize: 16
          }}
          onClick={openStarChartsAddHandler}
          spaceLeft={''}
        >
          <MdAddCircle size={32} />
          <span style={{ paddingRight: 18, paddingLeft:5 }}>Create Star Chart</span>
     
        </StarChartsButton>
      </StarChartsActionCol>
    </StarChartsActionWrapper>
  )
}

export default StarChartsActionPresentation
